import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { apiConnector } from '../../services/apiconnector'
import CountryCode from "../../data/countrycode.json"
import "../../App.css"
import { contactusEndpoint } from '../../services/apis'
import toast from 'react-hot-toast'

const ContactUsForm = () => {

    const [loading, setLoading] = useState(false)
    const {
        register,
        handleSubmit,
        reset,
        formState:{errors, isSubmitSuccessful}
    } = useForm()

    const submitContactForm = async (data) => {
        try{
            setLoading(true);
            const response = await apiConnector("POST", contactusEndpoint.CONTACT_US_API, data);

            console.log("Logging response", response);

            setLoading(false);

            toast.success("Message Sent Successfully")

        } catch(error) {
            console.log("Error", error.message);
            setLoading(false);
        }
    }

    useEffect(() => {
        if(isSubmitSuccessful) {
            reset({
                email: "",
                firstname: "",
                lastname: "",
                message: "",
                phonenumber: "",
            })
        }
    },[reset, isSubmitSuccessful])


  return (
    <form onSubmit={handleSubmit(submitContactForm)}
    className='flex flex-col gap-7'
    >
            {/*  Name */}
            <div className='flex flex-col lg:flex-row gap-5'>

                <div className='flex flex-col gap-2 lg:w-[48%]'>
                    <label htmlFor='firstname'
                    className='lable-style'
                    >First Name</label>
                    <input
                    type='text'
                    name='firstname'
                    id='firstname'
                    placeholder='Enter First Name'
                    className='form-style'
                    {...register("firstname", {required:true})}
                    />
                    {
                        errors.firstname && (
                            <span className="-mt-1 text-[12px] text-yellow-100">
                                Please Enter Your First Name
                            </span>
                        )
                    }
                </div>

                <div className='flex flex-col gap-2 lg:w-[48%]'>
                    <label htmlFor='lastname'
                    className="lable-style"
                    >Last Name</label>
                    <input
                        type='text'
                        name='lastname'
                        id='lastname'
                        placeholder='Enter Last Name'
                        className="form-style"
                        {...register("lastname")}
                    />
                    
                </div>

            </div>

            {/* Email*/}
            <div className='flex flex-col gap-2'>
                <label htmlFor='email'
                className='lable-style'
                >Email Address</label>
                <input
                type='email'
                name='email'
                id='email'
                placeholder='Enter Email Address'
                className='form-style'
                {...register("email", {required:true})}
                />
                {
                    errors.email && (
                        <span className='-mt-1 text-[12px] text-yellow-100'>
                            Please Enter Your Email Address
                        </span>
                    )
                }
            </div>

            {/* Phone NO */}
            <div className='flex flex-col gap-2'>
                <label htmlFor='phonenumber'
                className='lable-style'
                >Phone Number</label>

                <div className='flex gap-5'>
                    {/* Dropdown */}
                    <div className='flex flex-col w-[81px] gap-2'>
                        <select
                        name='countrycode'
                        id='countrycode'
                        className='form-style'
                        {...register("countrycode", {required:true})}
                        >
                            {
                                CountryCode.map((element, index) => {
                                    return (
                                        <option key={index} value={element.code}
                                        
                                        >
                                            {element.code} -{element.country}
                                        </option>
                                    )
                                })
                            }
                        </select>
                    </div>

                    {/* input phone no */}
                    <div className='flex w-[calc(100%-90px)] flex-col gap-2'>
                        <input
                            type='number'
                            name='phonenumber'
                            id='phonenumber'
                            placeholder='12345 67890'
                            className='form-style'
                            {...register("phonenumber", {
                                required:{value:true, message:"Please Enter Phone Number"}, 
                                maxLength:{value:10, message:"Invalid Phone Number"},
                                minLength:{value:8, message:"Invalid Phone Number"}}
                            )}
                        />
                    </div>
                </div>
                {
                    errors.phonenumber && (
                        <span className="-mt-1 text-[12px] text-yellow-100">
                            {errors.phonenumber.message}
                        </span>
                    )
                }
            </div>

            {/* Message */}
            <div className='flex flex-col gap-2'>
                <label htmlFor='message'
                className="lable-style"
                >Message</label>
                <textarea
                    name='message'
                    id='message'
                    cols="30"
                    rows="7"
                    placeholder='Enter Your Message here'
                    className="form-style"
                    {...register("message", {required:true})}
                />
                {
                    errors.message && (
                        <span className="-mt-1 text-[12px] text-yellow-100">
                            Please Enter Your Message
                        </span>
                    )
                }
            </div>

            {/* Button */}
            <button
            disabled={loading}
            type='submit'
            className={`rounded-md bg-yellow-50 text-center px-6 py-3 text-[13px] font-bold text-black shadow-[2px_2px_0px_0px_rgba(255,255,255,0.18)] ${
                !loading && 
                "transition-all duration-200 hover:scale-95 hover:shadow-none"
                }  disabled:bg-richblack-500 sm:text-[16px] "
            }`} 
            >
                Send Message
            </button>
        
    </form>
  )
}

export default ContactUsForm